import {random, texture} from "p3";
import definitions from "../../../definitions";
import GameScene from "../../../scenes/GameScene";
import Entity from "../../Entity";

export default class CatapultPellet extends Entity {
    constructor(startX, startY, targetX, targetY) {
        super();

        this._startX = startX;
        this._startY = startY;
        this._targetX = targetX;
        this._targetY = targetY;
        this._speed = 400;
        this._angle = null;

        this._collidedWithEnemy = false;
        this._collidedWithGround = false;

        this.collisionRadius = 50;
        this.collisionEnabled = true;
        this.collisionDynamic = true;
    }

    init() {
        this.addViewWithTexture(texture("prop_catapult_furball"));
        this._view.anchor.set(0.5);
        this._view.scale.set(0.4);
        this.x = this._startX;
        this.y = this._startY;

        this._angle = new P3.Vector2(this._targetX - this._startX, this._targetY - this._startY).angle;
        
        super.init();
    }

    update() {

        if(this._collidedWithEnemy)
            return false;

        super.update();
        
        this.x += (Math.cos(this._angle) * this._speed) * window.dt;
        let p = (this.x - this._startX) / (this._targetX - this._startX);
        this.y = this._startY + (Math.min(1,p) * (this._targetY - this._startY));
        this.y -= Math.abs(Math.sin(p*3) * 75);
        
        if(p > 1) {
            if (this.alpha == 1) {
                P3.audio.playSound([
                    "sfx_ivandoe_footstep_earth_00",
                    "sfx_ivandoe_footstep_earth_01",
                    "sfx_ivandoe_footstep_earth_02",
                    "sfx_ivandoe_footstep_earth_03"
                ]);
            }
            this.alpha = 1-Math.max((p-1) / 0.75, 0);
            if (this.alpha <= 0){
                return false;
            }
        }

        return true;
    }

    /**
     * @param {Entity} entity
     * @param {P3.Vector2} v
     */
    onCollisionEntity(entity, v) {
        super.onCollisionEntity(entity, v);
        if (entity.hostile && !this._collidedWithEnemy && this.alpha > 0.5 && !entity.isDead) {
            P3.audio.playSound("sfx_ivandoe_hit_enemy");
            this._collidedWithEnemy = true;
            //console.log(entity.health);
            GameScene.active.damageEnemy(entity, this.position, 1, random(200, 300));
        }
    }
}

CatapultPellet.range = 500;